
<template>
  <div class="grade-icon">
    <span>{{ grade }}</span>
  </div>
</template>

<script>
/* eslint-disable no-nested-ternary */
export default {
  name: 'GradeIcon',
  props: {
    game: {
      type: Object,
      required: true,
    },
  },
  computed: {
    grade() {
      return this.game.grade === -1 ? 'Pre-K' : this.game.grade === 0 ? 'K' : this.game.grade;
    },
  },
};
</script>

<style lang="scss" scoped>
.grade-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  height: 50px;
  width: 50px;
  background: #4255FF;
  border-radius: 10px;
}
</style>
